import angular from 'angular';

import TabHeaderComponent from './components/tab-header/tab-header-component';

export default angular.module('tab-component', []).component('tabHeader', new TabHeaderComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/tab/tab-component.js